const weddingGarlands = [
  {
    id: 'marigold-mala',
    title: 'Traditional Marigold Mala',
    subtitle: 'Hand-woven by Master Artisans',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuA-5FKBnOzYkM43volrxnIB3CjIfUqGrKIKqur7XwApRmFsmLDdgl7ivwOtgzeiQA5zFI191vl8PF0_YHaOsoICrj3dhzQlpxnQ64ZDdW7_hj3CLuoDXwP-erWxsczMEUFE_p9MSmeLaycPc9NrY-5vEWxAxDyLX6qZe1OMSVRqEewrNlxsrkeZNK3qEPEmHOjOqaYDifiIEaecy4CrQyysI0tX3m_j9PYueGaibEdISo433FF09UIoGhKCdfYl5FSNC8ZH6qY1zE5s',
    startingFrom: '₹5,500'
  },
  {
    id: 'jasmine-swirls',
    title: 'Fragrant Jasmine Swirls',
    subtitle: 'Premium South Indian Style',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCYob_nwG45qwKxbgjG5aQ2CJMOcKT55l_lWvcqG5DhQsSXHeEA41-PpO9gzx2w6qt10aeJIU6IchmsOTZ0V5VcIJMYnP6ueH1ZWVaoVqCo2cckY6F1tmx7ryLvRA10exZtrCLQItAt8EpbE8lNRkR_AcCdzeffnaHk4AaC1s6AOTsftgeaewe1jeoGxNSh21eNtTLKlfKoK8V5akCBZj544ShjaxBMUHylrotcv-qcBdiMGagZAc6T_lF38Hof4_NFgzaofbOIPvf9',
    startingFrom: '₹8,000'
  },
  {
    id: 'royal-rose-garland',
    title: 'Royal Rose Garland',
    subtitle: 'Export Quality Velvet Roses',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCjDK3r4I4dzl9ntdP-jb6cJxrZKAaQ7RL0ggNQcanq5qxg1rgd0i1CiDC0qvQJd8HwqY_4w8DsutUQPcnt581pZ6ZoGHqT_AMcmu0jpk8qQPBEK5VJgfD2K55guocsN-BtmHG1mlgrPjJ7K8jZQytNUTBSF2uufUWDOe8ejyr3wd6r2h7ay5k5O6y7hh-UAbkKDMUYNiow45IZPsZXwQHAYxOXdTW3y5QKD90MylyKPmuJeEhmk_lHp7Gv8pEAac4mkm869yy75uCt',
    startingFrom: '₹12,500'
  }
];

export default weddingGarlands;
